import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import ReflectionPage from "@/pages/ReflectionPage";
import HarmoniaPage from "@/pages/HarmoniaPage";
import JourneyRequestPage from "@/pages/JourneyRequestPage";
import OfferingPage from "@/pages/OfferingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/reflections/:slug" element={<ReflectionPage />} />
          <Route path="/harmonia" element={<HarmoniaPage />} />
          <Route path="/journeys/:slug" element={<JourneyRequestPage />} />
          <Route path="/offerings/:slug" element={<OfferingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A281F",
            color: "#F4EFE6",
            border: "1px solid rgba(244,239,230,0.15)",
            fontFamily: "Manrope, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
